// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { useState } from 'react';

function traverseFileTree(item, path, fileList) {
  if (item.isFile) {
    item.file((file) => {
      fileList.push({ file, relativePath: path + file.name });
    });
  } else if (item.isDirectory) {
    const dirReader = item.createReader();
    dirReader.readEntries((entries) => {
      for (const entry of entries) {
        traverseFileTree(entry, path + item.name + '/', fileList);
      }
    });
  }
}

/**
 * Manages drag/drop state and file-tree traversal for the upload modal.
 * Returns drag handlers and a callback to receive the parsed files.
 */
export function useFileDropzone(onFilesReceived) {
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') setDragActive(true);
    else if (e.type === 'dragleave') setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const items = e.dataTransfer.items;
    if (items) {
      const fileList = [];
      for (const it of items) {
        const entry = it.webkitGetAsEntry();
        if (entry) traverseFileTree(entry, '', fileList);
      }
      // Allow async readers to populate before reading.
      setTimeout(() => {
        if (fileList.length > 0) onFilesReceived(fileList, 'folder');
      }, 500);
    } else if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const fileArray = Array.from(e.dataTransfer.files).map(f => ({
        file: f,
        relativePath: f.name,
      }));
      onFilesReceived(fileArray, 'files');
    }
  };

  return { dragActive, handleDrag, handleDrop };
}
